module.exports = __webpack_public_path__ + "static/img/bg-fr.ffb52acb.png";